module["exports"] = [
  "Ing.",
  "Mgr.",
  "JUDr.",
  "MUDr."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/name/prefix.js
 ** module id = 1045
 ** module chunks = 0
 **/